export enum ResponseStatus {
    Success,
    Failed,
}

export class ServiceResponse<T = null> {
    success: boolean;
    message: string;
    responseObject: T;
    statusCode: number;

    constructor(status: ResponseStatus, message: string, responseObject: T, statusCode: number) {
        this.success = status === ResponseStatus.Success;
        this.message = message;
        this.responseObject = responseObject;
        this.statusCode = statusCode;
    }
}